export const SHADOW = {
  "Shadow.100": {
    defaultValue: "0 1px 4px 0 var(--kf-shadow-color)"
  },
  "Shadow.200": {
    defaultValue: "0 2px 6px 0 var(--kf-shadow-color)"
  },
  "Shadow.300": {
    defaultValue: "0 2px 12px 0 var(--kf-shadow-color)"
  },
  "Shadow.500": {
    defaultValue: "0 2px 16px 0 var(--kf-shadow-color)"
  }
};
